/* eslint-disable react/destructuring-assignment */
import MaterialUiRating from '@mui/material/Rating';
import Star from '@mui/icons-material/Star';
import React from 'react';
const Rating = (props) => {
    return (React.createElement(MaterialUiRating, Object.assign({ emptyIcon: React.createElement(Star, { color: "inherit", fontSize: "inherit" }) }, props, { onChange: (event) => {
            const { value } = event.target;
            const numVal = !Number.isNaN(Number(value)) ? Number(value) : null;
            if (props.onChange) {
                props.onChange(event, numVal);
            }
        } })));
};
/**
 * @deprecated
 */
export default Rating;
